import { notify } from 'utils/reduxUtils';

export const types = {
  ADD_NEW_EMAIL_NOTIFICATION_SETTING_ERROR:
    'settings/profile/ADD_NEW_EMAIL_NOTIFICATION_SETTING_ERROR',
  ADD_NEW_EMAIL_NOTIFICATION_SETTING_REQUEST:
    'settings/profile/ADD_NEW_EMAIL_NOTIFICATION_SETTING_REQUEST',
  ADD_NEW_EMAIL_NOTIFICATION_SETTING_SUCCESS:
    'settings/profile/ADD_NEW_EMAIL_NOTIFICATION_SETTING_SUCCESS',
  DELETE_EMAIL_NOTIFICATION_SETTING_ERROR:
    'settings/profile/DELETE_EMAIL_NOTIFICATION_SETTING_ERROR',
  DELETE_EMAIL_NOTIFICATION_SETTING_REQUEST:
    'settings/profile/DELETE_EMAIL_NOTIFICATION_SETTING_REQUEST',
  DELETE_EMAIL_NOTIFICATION_SETTING_SUCCESS:
    'settings/profile/DELETE_EMAIL_NOTIFICATION_SETTING_SUCCESS',
  FETCH_GROUP_EMAIL_SETTINGS_ERROR:
    'settings/profile/FETCH_GROUP_EMAIL_SETTINGS_ERROR',
  FETCH_GROUP_EMAIL_SETTINGS_REQUEST:
    'settings/profile/FETCH_GROUP_EMAIL_SETTINGS_REQUEST',
  FETCH_GROUP_EMAIL_SETTINGS_SUCCESS:
    'settings/profile/FETCH_GROUP_EMAIL_SETTINGS_SUCCESS',
  UPDATE_GROUP_EMAIL_SETTINGS_ERROR:
    'settings/profile/UPDATE_GROUP_EMAIL_SETTINGS_ERROR',
  UPDATE_GROUP_EMAIL_SETTINGS_REQUEST:
    'settings/profile/UPDATE_GROUP_EMAIL_SETTINGS_REQUEST',
  UPDATE_GROUP_EMAIL_SETTINGS_SUCCESS:
    'settings/profile/UPDATE_GROUP_EMAIL_SETTINGS_SUCCESS',
};

export const fetchGroupEmailSettings = {
  error: notify(
    ({ error }) => ({
      type: types.FETCH_GROUP_EMAIL_SETTINGS_ERROR,
      payload: { error },
    }),
    'Error fetching team members.',
  ),
  request: () => ({
    type: types.FETCH_GROUP_EMAIL_SETTINGS_REQUEST,
    payload: {},
  }),
  success: ({ emailNotificationSettings }) => ({
    type: types.FETCH_GROUP_EMAIL_SETTINGS_SUCCESS,
    payload: { emailNotificationSettings },
  }),
};

export const updateGroupEmailSettings = {
  error: notify(
    ({ error }) => ({
      type: types.UPDATE_GROUP_EMAIL_SETTINGS_ERROR,
      payload: { error },
    }),
    'Error updating team members.',
  ),
  request: ({ emailNotificationSettings }) => ({
    type: types.UPDATE_GROUP_EMAIL_SETTINGS_REQUEST,
    payload: { emailNotificationSettings },
  }),
  success: notify(
    ({ emailNotificationSettings }) => ({
      type: types.UPDATE_GROUP_EMAIL_SETTINGS_SUCCESS,
      payload: { emailNotificationSettings },
    }),
    'Email notifications settings updated.',
  ),
};

export const addNewEmailNotificationSetting = {
  error: notify(
    (error) => ({
      type: types.ADD_NEW_EMAIL_NOTIFICATION_SETTING_ERROR,
      payload: error,
    }),
    'Error adding new email.',
  ),
  request: ({ emailNotificationSetting }) => ({
    type: types.ADD_NEW_EMAIL_NOTIFICATION_SETTING_REQUEST,
    payload: { emailNotificationSetting },
  }),
  success: ({ emailNotificationSetting }) => ({
    type: types.ADD_NEW_EMAIL_NOTIFICATION_SETTING_SUCCESS,
    payload: { emailNotificationSetting },
  }),
};

export const deleteEmailNotificationSetting = {
  error: notify(
    ({ error }) => ({
      type: types.DELETE_EMAIL_NOTIFICATION_SETTING_ERROR,
      payload: { error },
    }),
    'Error deleting email.',
  ),
  request: ({ emailNotificationSettingId }) => ({
    type: types.DELETE_EMAIL_NOTIFICATION_SETTING_REQUEST,
    payload: { emailNotificationSettingId },
  }),
  success: ({ emailNotificationSettings }) => ({
    type: types.DELETE_EMAIL_NOTIFICATION_SETTING_SUCCESS,
    payload: { emailNotificationSettings },
  }),
};
